import { startFormListeners } from "form/listeners"
import { startMaplisteners } from "./listeners"
import { IMapService } from "./model"
import { fitFeaturesOnMap, panAndZoomTo, panTo, zoomTo, zoomToRect } from "./tools/common"

startMaplisteners()
startFormListeners()

export const mapSVC: IMapService = {
  panTo,
  zoomTo,
  zoomToRect,
  panAndZoomTo,
  fitFeaturesOnMap
}
